import { render } from "./WhatsAppModalSidebarRightChatMessageContainerMessagesMenu.vue?vue&type=template&id=73a64c92"
import script from "./WhatsAppModalSidebarRightChatMessageContainerMessagesMenu.vue?vue&type=script&lang=js"
export * from "./WhatsAppModalSidebarRightChatMessageContainerMessagesMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__